import { apiFetch, ERRO_CONEXAO } from "../../Shared/Api/apiClient";

// Erro com mensagem pronta para a tela. O 422 traz o motivo vindo da API.
// Sem rede ou sem sessao, o apiFetch ja lanca com a mensagem certa.
async function requisitar(caminho, opcoes = {}) {
  const resposta = await apiFetch(caminho, {
    ...opcoes,
    headers: { "Content-Type": "application/json", ...opcoes.headers },
  });

  const dados = await resposta.json().catch(() => null);

  if (!resposta.ok) {
    const mensagem =
      resposta.status === 404
        ? "Proposta não encontrada."
        : resposta.status === 422 && dados?.msg
          ? dados.msg
          : ERRO_CONEXAO;
    const erro = new Error(mensagem);
    erro.status = resposta.status;
    throw erro;
  }

  return dados;
}

export function listarPropostas({ status, busca, pagina, limite }, { signal } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (busca) params.set("busca", busca);
  if (pagina > 1) params.set("pagina", String(pagina));
  if (limite) params.set("limite", String(limite));

  const query = params.toString();
  return requisitar(`/ERP/Propostas${query ? `?${query}` : ""}`, { signal });
}

export function buscarProposta(numero, { signal } = {}) {
  return requisitar(`/ERP/Propostas/${encodeURIComponent(numero)}`, { signal });
}

export function alterarStatusProposta(numero, { status, observacao }) {
  return requisitar(`/ERP/Propostas/${encodeURIComponent(numero)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status, observacao }),
  });
}

export function excluirProposta(numero) {
  return requisitar(`/ERP/Propostas/${encodeURIComponent(numero)}`, {
    method: "DELETE",
  });
}
